import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOSchema from '@/components/base/SEOSchema';
import HeroSection from './components/HeroSection';
import FeaturedManga from './components/FeaturedManga';
import CategoryShowcase from './components/CategoryShowcase';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';
import { faqList } from '@/mocks/faqData';

const faqSchemaData = {
  mainEntity: faqList.slice(0, 5).map((faq) => ({
    '@type': 'Question' as const,
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer' as const,
      text: faq.answer,
    },
  })),
};

export default function Home() {
  return (
    <>
      <SEOSchema type="Organization" />
      <SEOSchema type="WebSite" />
      <SEOSchema
        type="WebPage"
        data={{
          name: '虫虫漫画 - 首页',
          description: '虫虫漫画打造二次元动漫世界，专注于提供沉浸式韩国漫画体验，从界面到内容设计都围绕深度阅读，让您全身心投入漫画情节。',
          url: window.location.origin + '/',
        }}
      />
      <SEOSchema type="FAQPage" data={faqSchemaData} />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedManga />
          <CategoryShowcase />
          <FAQSection />
          <NewsletterSection />
        </main>
        <Footer />
      </div>
    </>
  );
}